import { initErrorLogger } from "@venuepos/react-common";

import { AppRegistry } from "react-native";
import appInfo from "../app.json";
import "@fontsource-variable/nunito-sans/wght.css";
import "@fontsource-variable/montserrat/wght.css";
import "../public/index.css";
import App from "./app";

// This global constant is used in the Admin app in place of the "VP_ENV"
export const ENV_HOSTNAME = globalThis.location.hostname;

initErrorLogger(appInfo.sentryDSN);
AppRegistry.registerComponent(appInfo.name, () => App);
AppRegistry.runApplication(appInfo.name, {
    rootTag: document.getElementById("root"),
});
